import React from 'react';
import PropTypes from 'prop-types';
import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class JobHistoryExcelSheet extends React.Component {
  componentDidMount = () => {
    this.Interval = setInterval(this.props.unmountExcelSheet.bind(this), 2500);
  }

  componentWillUnMount = () => clearInterval(this.Interval);

  render = () => {
    const formattedAppts = this.props.appts.map((a) => {
      const { crew, apptType, startDate, endDate, phase = 'N/A' } = a;
      const docs = !phase || typeof phase === 'string' ? [] : phase.document_uploads;
      return {
        crew,
        apptType,
        startDate,
        endDate,
        projectNumber: !phase || typeof phase === 'string' ? 'N/A' : phase.project_number,
        crewInspection: docs.length && docs.some(d =>
          d.document_name.includes('ID:')) ? 'YES' : 'NO',
      };
    }) || [];

    return (<ExcelFile hideElement>
      <ExcelSheet data={formattedAppts || []} name="Phase List">
        <ExcelColumn label="Crew" value="crew" />
        <ExcelColumn label="Project Number" value="projectNumber" />
        <ExcelColumn label="Appt. Type" value="apptType" />
        <ExcelColumn label="Start Date" value="startDate" />
        <ExcelColumn label="End Date" value="endDate" />
        <ExcelColumn label="Has Inspection" value="crewInspection" />
      </ExcelSheet>
    </ExcelFile>);
  }
}

JobHistoryExcelSheet.propTypes = {
  appts: PropTypes.array, unmountExcelSheet: PropTypes.func,
};

export default JobHistoryExcelSheet;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/jobHistory/components/JobHistoryExcelSheet.jsx